const en_login = {
    title: "Sign In",
    password: "Password",
    forgotpass: "Forgot password?",
    submit: "Submit"
}

export default en_login;